import React, {useState, useEffect} from 'react';
import GoogleTranslate from '../GoogleTranslate'; // ajuste le chemin selon ta structure
import './Navbar.css';
import logo from '../../assets/images/logo_hoag.png'; // Remplace avec le chemin réel de ton logo
import enFlag from '../../assets/images/flag_usa.png'; // Drapeau FR rond
import frFlag from '../../assets/images/flag_france.webp'; // Drapeau EN rond
import { FaBars, FaTimes } from 'react-icons/fa'; // icons from react-icons

const Navbar = () => {
  const [lang, setLang] = useState('fr');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleChange = (e) => {
    setLang(e.target.value);
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // Cette fonction forcera le widget Google Translate à changer la langue quand tu modifies ton select
  const changeGoogleTranslateLang = (languageCode) => {
    const select = document.querySelector('select.goog-te-combo');
    if (select) {
      select.value = languageCode;
      // Déclenche un événement 'change' sur le select Google Translate
      select.dispatchEvent(new Event('change'));
    }
  };

  const handleChangeLg = (e) => {
    const newLang = e.target.value;
    setLang(newLang);
    changeGoogleTranslateLang(newLang);
  };

  // Au premier chargement, on synchronise la langue par défaut avec Google Translate
  useEffect(() => {
    changeGoogleTranslateLang(lang);
  }, []);
  return (
  <nav className="navbar notranslate">
      <div className="navbar-logo">
        <a href="/"><img src={logo} alt="Logo" /></a>
      </div>

      <div className="navbar-toggle" onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        <li><a href="/">Accueil</a></li>
        <li><a href="/vision">Vision</a></li>
        <li><a href="/service">Services</a></li>
        <li><a href="/methodologie">Méthodologie</a></li>
        <li><a href="/contact">Contact</a></li>
        <li><a href="https://hoagtarget.blogspot.com/" target='_blank'>Blog</a></li>
        <li><a href="/apropos">À propos</a></li>

        {/* Langue visible dans le menu mobile */}
        
        {/*<li className="navbar-language-mobile">
            <img
            src={lang === 'fr' ? frFlag : enFlag}
            alt={lang.toUpperCase()}
            className="flag-icon"
            />
            <select value={lang} onChange={handleChangeLg}>
            <option value="fr">FR</option>
            <option value="en">EN</option>
            </select>
        </li>*/}
      </ul>

      {/* Widget Google Translate */}
      {/* Place Google Translate en dehors du menu UL */}
      <div className="navbar-language-global">
        <GoogleTranslate />
      </div>
      

      {/*
      <div className="navbar-language">
        <img src={lang === 'fr' ? frFlag : enFlag} alt={lang.toUpperCase()} className="flag-icon" />
        <select value={lang} onChange={handleChangeLg}>
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
      </div>
      */}

    </nav>
  );
};

export default Navbar;
